<template>
	<v-list class="w-100" dense @change="$emit('clicked')">
		<v-list-item @click="vLink('dashboard')">
			<v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
			<v-list-item-title>Dashboard</v-list-item-title>
		</v-list-item>

		<v-list-item @click="vLink('projects.index')">
			<v-list-item-icon><v-icon>mdi-folder-check</v-icon></v-list-item-icon>
			<v-list-item-title>Projects</v-list-item-title>
		</v-list-item>

		<template v-if="auth.user_type === 1">
			<v-list-item @click="vLink('stats.reports')">
				<v-list-item-icon><v-icon>mdi-chart-box</v-icon></v-list-item-icon>
				<v-list-item-title>Stats</v-list-item-title>
			</v-list-item>

			<v-list-item @click="vLink('invoices.index')">
				<v-list-item-icon><v-icon>mdi-bank-check</v-icon></v-list-item-icon>
				<v-list-item-title>Invoices</v-list-item-title>
			</v-list-item>

			<v-list-item @click="vLink('clients.index')">
				<v-list-item-icon><v-icon>mdi-account-circle-outline</v-icon></v-list-item-icon>
				<v-list-item-title>Clients</v-list-item-title>
			</v-list-item>

			<v-list-item @click="vLink('users.index')">
				<v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
				<v-list-item-title>Users</v-list-item-title>
			</v-list-item>

			<v-divider class="my-4" />

			<v-list-item @click="vLink('settings')">
				<v-list-item-icon><v-icon>mdi-cog</v-icon></v-list-item-icon>
				<v-list-item-title>Settings</v-list-item-title>
			</v-list-item>

			<v-divider class="my-4" />

			<v-list-item @click="vLink('logout', null, { method: 'POST' })">
				<v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
				<v-list-item-title>Logout</v-list-item-title>
			</v-list-item>
		</template>
	</v-list>
</template>
<script>

export default {
	props: {
		//
	},
	data () {
		return {
			auth: this.$page.props.auth
		}
	}
}
</script>
